import { Shuffle } from "lucide-react";

import InputField from "@components/fields/input-field";
import LoadingButton from "@components/ui-components/loading-button";
import Modal from "@components/ui-components/modal";
import SelectField from "@components/fields/select-field";
import { FREQUENCY_OPTIONS, PAYMENT_MODEL_OPTIONS, PLATFORM_OPTIONS } from "@constants/panel/common";
import { RECORD_STATUS_OPTIONS } from "../misc/constants";

const BrandCreateModal = ({ open, methods, loading, onClose, onSubmit, onRegenerateExtId }) => {
    const { control, formState: { errors } } = methods;

    return (
        <Modal
            open={open}
            width="lg"
            onClose={onClose}
            title="Create brand"
            subtitle="POST /api/onboarding/account/v1 — sent with the session's bearer token."
            footer={
                <>
                    <LoadingButton color="neutral" icon={Shuffle} text="New external id" onClick={onRegenerateExtId} />
                    <LoadingButton color="neutral" text="Cancel" onClick={onClose} />
                    <LoadingButton text="Create brand" loading={loading} loadingText="Creating…" onClick={onSubmit} />
                </>
            }>
            <form
                className="grid gap-x-4 sm:grid-cols-2"
                onSubmit={(event) => {
                    event.preventDefault();
                    onSubmit();
                }}>
                <InputField control={control} errors={errors} name="name" id="brand-name" label="Brand name" placeholder="Brand 5" required />
                <InputField
                    control={control}
                    errors={errors}
                    name="ext_id"
                    id="brand-ext-id"
                    label="External id"
                    placeholder="6a79d04b5eceb7d70dba1907"
                    desc="The brand's id on the tracking platform — prefilled, replace it if the platform already has one"
                    required />
                <SelectField control={control} errors={errors} name="status" label="Status" options={RECORD_STATUS_OPTIONS} required />
                <SelectField control={control} errors={errors} name="payment_model" label="Payment model" options={PAYMENT_MODEL_OPTIONS} required />
                <SelectField control={control} errors={errors} name="debit_note_frequency" label="Debit note frequency" options={FREQUENCY_OPTIONS} required />
                <SelectField control={control} errors={errors} name="platform_name" label="Platform" options={PLATFORM_OPTIONS} required />
                <InputField control={control} errors={errors} name="kyc_window" id="brand-kyc-window" type="number" label="KYC window (days)" required />
                <InputField className="sm:col-span-2 mb-1" control={control} errors={errors} name="notes" id="brand-notes" label="Notes" placeholder="Onboarded via affiliate referral" />
            </form>
        </Modal>
    );
};

export default BrandCreateModal;
